export default "__VITE_ASSET__CkPT5NkJ__"